import { Link } from 'react-router-dom';
import HiringCriteria from '../../components/HiringCriteria';
import TechStack from '../../components/TechStack';

function SoftwareEngineer() {
  const requirements = [
    'Currently pursuing a Bachelor\'s degree in Computer Science or related field',
    'Strong programming fundamentals in JavaScript/TypeScript',
    'Experience with React and modern web technologies',
    'Excellent problem-solving skills',
    'Strong understanding of web development principles',
    'Familiarity with version control systems (Git)',
    'Good communication and teamwork skills'
  ];

  const responsibilities = [
    'Develop and maintain features for our e-commerce platform',
    'Write clean, maintainable, and efficient code',
    'Collaborate with cross-functional teams to define and implement new features',
    'Participate in code reviews and contribute to technical discussions',
    'Help improve our development processes and practices',
    'Debug production issues and implement fixes',
    'Write technical documentation'
  ];

  const benefits = [
    // Universal Benefits
    'A Job offer at the end',
    'Fast track your career 5 years from learning',
    'How to build a real business',
    'How get your business funded',
    // Position Specific Benefits
    'Tech; how to build and launch big SaaS with AI and launch in 14 days',
    'Real-world experience in a fast-growing startup',
    'Mentorship from experienced developers',
    'Flexible remote work schedule',
    'Exposure to latest technologies and best practices',
    'Work on meaningful projects that impact real businesses'
  ];

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
        {/* Header */}
        <div className="mb-16">
          <Link 
            to="/internship"
            className="text-[#0049ac] hover:text-[#0049ac]/90 mb-8 inline-flex items-center"
          >
            ← Back to Internship Program
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mt-4">Software Engineering Intern</h1>
          <div className="mt-4 flex flex-wrap gap-4">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
              Engineering
            </span>
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
              Remote
            </span>
            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
              3-6 months
            </span>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Left Column - Main Description */}
          <div className="lg:col-span-2 space-y-8">
            <HiringCriteria />

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Tech Stack</h2>
              <p className="text-gray-600 mb-4">
                Our platform is built with modern technologies to ensure scalability, performance, and maintainability.
              </p>
              <TechStack />
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">About the Role</h2>
              <p className="text-gray-600">
                Join our engineering team and help build the future of e-commerce in the MENAP region. 
                As a Software Engineering Intern at SellAbroad, you'll work on real projects that help 
                businesses expand their reach across multiple marketplaces. You'll gain hands-on 
                experience with modern web technologies while being mentored by experienced developers.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">What You'll Do</h2>
              <ul className="space-y-3">
                {responsibilities.map((responsibility, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#0049ac] mr-2">•</span>
                    <span className="text-gray-600">{responsibility}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Requirements</h2>
              <ul className="space-y-3">
                {requirements.map((requirement, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#0049ac] mr-2">•</span>
                    <span className="text-gray-600">{requirement}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Benefits</h2>
              <ul className="space-y-3">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-[#0049ac] mr-2">•</span>
                    <span className="text-gray-600">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Column - Application Card */}
          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-xl p-6 sticky top-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">Apply Now</h2>
              <p className="text-gray-600 mb-6">
                Ready to start your journey with SellAbroad? Submit your application today.
              </p>
              <Link
                to="/internship/apply"
                className="w-full inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-[#0049ac] hover:bg-[#0049ac]/90"
              >
                Submit Application
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SoftwareEngineer;